import { EmmaSpace } from '@axa-asia/emma-stylesheet';
import classNames from 'classnames';
import React from 'react';
import AddressAbbreviationList from '../../components/ChangeAddressComponents/AddressAbbreviationList';
import { useMobileTopBar } from '@axa-asia/utils';
import { useSelector } from 'react-redux';
import { getAddressAbbreviationLabel } from '../../selectors/changeAddressSelector';
import { resolveLocalizedText } from '../../../../utils';

const AddressAbbreviationContainer = () => {
  const { title } = useSelector(getAddressAbbreviationLabel);
  useMobileTopBar({
    title: resolveLocalizedText(title),
    showCloseBtn: false,
  });

  return (
    <div className={classNames(EmmaSpace.ml16, EmmaSpace.mr16, EmmaSpace.mb48)}>
      <AddressAbbreviationList tableHeaderClassName={EmmaSpace.pt24} />
    </div>
  );
};

export default AddressAbbreviationContainer;
